export const TOURS_EMPTY        = 'TOURS_EMPTY'
export const TOURS_DASHBOARD    = 'TOURS_DASHBOARD'
export const TOURS_DASHBOARD_FILTERS  = 'TOURS_DASHBOARD_FILTERS'
export const TOURS_DASHBOARD_STATE    = 'TOURS_MENU_STATE'
export const TOURS_MENU         = 'TOURS_MENU'
export const TOURS_MENU_FILTERS = 'TOURS_MENU_FILTERS'
export const TOURS_MENU_STATE   = 'TOURS_MENU_STATE'
export const TOURS_EXPLORE      = 'TOURS_EXPLORE'
export const TOURS_USERS        = 'TOURS_USERS'
export const TOURS_GROUPS       = 'TOURS_GROUPS'
export const TOURS_WORKSPACE    = 'TOURS_WORKSPACE'
export const TOURS_CONFIG       = 'TOURS_CONFIG'

export const UPDATE_TOURS_DASHBOARD  = 'UPDATE_TOURS_DASHBOARD'
export const UPDATE_TOURS_MENU       = 'UPDATE_TOURS_MENU'
export const UPDATE_TOURS_EXPLORE    = 'UPDATE_TOURS_EXPLORE'
export const UPDATE_TOURS_USERS      = 'UPDATE_TOURS_USERS'
export const UPDATE_TOURS_GROUPS     = 'UPDATE_TOURS_GROUPS'

export const TOURS_DASHBOARD_SUCCESS  = 'TOURS_DASHBOARD_SUCCESS'
export const TOURS_DASHBOARD_FAILURE  = 'TOURS_DASHBOARD_FAILURE'
export const TOURS_MENU_SUCCESS       = 'TOURS_MENU_SUCCESS'
export const TOURS_MENU_FAILURE       = 'TOURS_MENU_FAILURE'
export const TOURS_EXPLORE_SUCCESS    = 'TOURS_EXPLORE_SUCCESS'
export const TOURS_EXPLORE_FAILURE    = 'TOURS_EXPLORE_FAILURE'
export const TOURS_USERS_SUCCESS      = 'TOURS_USERS_SUCCESS'
export const TOURS_USERS_FAILURE      = 'TOURS_USERS_FAILURE'
export const TOURS_GROUPS_SUCCESS     = 'TOURS_GROUPS_SUCCESS'
export const TOURS_GROUPS_FAILURE     = 'TOURS_GROUPS_FAILURE'
export const TOURS_WORKSPACE_SUCCESS  = 'TOURS_WORKSPACE_SUCCESS'
export const TOURS_WORKSPACE_FAILURE  = 'TOURS_WORKSPACE_FAILURE'
export const TOURS_CONFIG_SUCCESS     = 'TOURS_CONFIG_SUCCESS'
export const TOURS_CONFIG_FAILURE     = 'TOURS_CONFIG_FAILURE'

export const TOURS_MENU_ONLY_VIEW     = 'TOURS_MENU_ONLY_VIEW'
